/* eslint-disable import/no-extraneous-dependencies */
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0

import GetChatList from '../api/backend/GetKaiinChatNewLineChatListApi';
import GetChatData from '../api/backend/GetKaiinChatLineChatListApi';
import SendChat from '../api/backend/SendCompanyMessageApi';
import CloseInquiry from '../api/backend/ChatProhibitedApi';
import SendMessageToKaiinApi from '../api/backend/SendMessageToKaiinApi';
import { LoginProvider } from '../constants/auth';

/**
 * @class LineService
 */
export class LineService {
  constructor(private idToken: string, private loginProvider: LoginProvider) {}
  listInquiries(cursor?: unknown) {
    return new GetChatList(this.idToken).get(cursor);
  }
  listMessages(matchId: string) {
    return new GetChatData(this.idToken).get(matchId);
  }
  sendMessage(userId: string, message: string) {
    if (this.loginProvider === 'line') {
      return new SendMessageToKaiinApi(this.idToken).send(userId, message);
    } else {
      return new SendChat(this.idToken).send(userId, message);
    }
  }
  close(matchId: string) {
    return new CloseInquiry(this.idToken).close(matchId);
  }
}

export default LineService;
